import { useSessionStorage } from '@vueuse/core'
import { StorageKeys } from '@/constants/storageKey'

/**
 * - isRwgActive：建單後 rwgTokenAvailable=false，整個 funnel 不再帶 rwg
 * - fromNearbyClick：nearby 卡片點擊 set → 下一頁 branch-detail 用，避免 Branch Page Viewed 被 rwg 蓋掉
 */
export function useRwgSource() {
  const route = useRoute()
  const rwgToken = useSessionStorage<string>(StorageKeys.GOOGLE_APPOINTMENT_TOKEN, '')
  const rwgTokenConsumed = useSessionStorage<boolean>(StorageKeys.GOOGLE_APPOINTMENT_TOKEN_CONSUMED, false)
  const fromNearbyClick = useSessionStorage<string>(StorageKeys.FROM_NEARBY_CLICK, '')

  const isRwgActive = computed(() => {
    if (rwgTokenConsumed.value) return false

    // RwG entry 帶 rwg_token，但 useGoogleAppointment 的 tryOnMounted，可能還沒寫進 sessionStorage，讀 query 作 fallback
    if (route.query.rwg_token) return true
    return !!rwgToken.value
  })

  return { isRwgActive, fromNearbyClick }
}
